<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-row mb-1">
      <span class="badge badge-light mt-auto mb-auto">{{ lineIndex + nodeData.seq }}</span>
      <b-form-input type="text" v-model="nodeData.name" placeholder="标题名称" class="w-50 h-auto"></b-form-input>
      <b-form-checkbox v-if="nodeData.parentId !== 0" type="checkbox" v-model="editAble" class="ml-2 mt-2 mb-2">
        可编辑
      </b-form-checkbox>
      <div v-if="editAble" class="ml-2 d-flex flex-row">
        <b-form-select id="formatSelect" v-model="format" :options="formatOptions"
                       class="h-75 m-auto"></b-form-select>
        <label for="formatSelect" class="text-nowrap m-auto">数据类型</label>
        <InputForInspectTemplate v-if="nodeData.format!==undefined"
                                 with-border
                                 :format="nodeData.format"
                                 :value.sync="nodeData.defaultValue"></InputForInspectTemplate>
      </div>
      <button type="button" class="btn btn-outline-secondary ml-2" @click="newChildNode({type:1})">新增标题</button>
      <button type="button" class="btn btn-outline-secondary ml-1" @click="newChildNode({type:2})">新增表格</button>
      <button type="button" class="btn btn-outline-danger ml-1" @click="emitRemoveNodeEvent"
              v-if="nodeData.parentId !== 0">删除
      </button>
    </div>
    <div v-for="(item,index) in nodeData.childNodes" :key="index" class="ml-2">
      <QualityInspectTemplateTitleUnit v-if="item.type===1" :node-data="item"
                                       :ref="'F' + index"
                                       :id="lineIndex + nodeData.seq + '.'+index"
                                       @removeNode="deleteNode(index)"
                                       :line-index="lineIndex + nodeData.seq + '.'"></QualityInspectTemplateTitleUnit>
      <QualityInspectTemplateTableUnit v-else-if="item.type===2" :node-data="item"
                                       :ref="'T' + index"
                                       @removeNode="deleteNode(index)"
                                       :line-index="lineIndex + nodeData.seq + '.'"></QualityInspectTemplateTableUnit>
    </div>
  </div>
</template>

<script>
import QualityInspectTemplateTableUnit
  from "@/views/sithMes/quality/inspectTemplate/cells/QualityInspectTemplateTableUnit";
import InputForInspectTemplate from "@/views/sithMes/quality/inspectTemplate/cells/InputForInspectTemplate";

export default {
  name: "QualityInspectTemplateTitleUnit",
  components: {InputForInspectTemplate, QualityInspectTemplateTableUnit},
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    lineIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editAble: false,
      formatOptions: [
        {value: "String", text: "文本"},
        {value: "Integer", text: "数字"},
        {value: "Boolean", text: "单选"},
      ],
      format: null
    }
  },
  mounted() {
    if (this.nodeData.format !== undefined && this.nodeData.format != null) {
      this.editAble = true;
    }
  },
  watch: {
    editAble(val, oldVal) {
      if (!val && oldVal) {
        this.format = null;
      } else if (val && !oldVal) {
        this.format = "String";
      }
    },
    format(val){
      this.$set(this.nodeData, 'format', val);
      let temp = "";
      if (val === "Integer") {
        temp = 0;
      }else if (val === "Boolean") {
        temp = false;
      } else {
        temp = null;
      }
      this.$set(this.nodeData, 'defaultValue', temp);
    }
  },
  methods: {
    newChildNode({type}) {
      if (!this.nodeData.hasOwnProperty('childNodes')) {
        this.nodeData.childNodes = [];
      }
      let maxSeq = 0;
      for (let item of this.nodeData.childNodes) {
        if (item.seq > maxSeq) {
          maxSeq = item.seq;
        }
      }
      this.nodeData.childNodes.splice(maxSeq, 0, {
        name: '',
        type: type,
        seq: maxSeq + 1,
        format: null,
        defaultValue: null,
      })
      this.$forceUpdate()
    },
    emitRemoveNodeEvent() {
      this.$emit('removeNode')
    },
    deleteNode(index) {
      this.$confirm('确认删除该节点及其子节点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let i = index + 1; i < this.nodeData.childNodes.length; i++) {
          this.nodeData.childNodes[i].seq--;
        }
        this.nodeData.childNodes.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.$forceUpdate()
      })
    },
    exportData() {
      if (this.nodeData.name == null || this.nodeData.name === '') {
        this.$message.error('存在未命名的标题');
        return null;
      }
      let result = JSON.parse(JSON.stringify(this.nodeData));
      if (this.nodeData.hasOwnProperty('childNodes')) {
        let tempList = [];
        for (let i = 0; i < result.childNodes.length; i++) {
          let item = result.childNodes[i];
          let refName = (item.type === 1 ? 'F' : 'T') + i;
          let exportData = this.$refs[refName][0].exportData();
          if (exportData == null) {
            return null;
          }
          tempList.push(exportData);
        }
        result.childNodes = tempList;
      }
      return result;
    }
  }
}
</script>

<style scoped>

</style>